import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardApiIsomorphicFetchEvent } from '#/modules/orgDashboard/api/listing/orgDashboardApiFetchEvent';
import { orgDashboardRepostEventRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardRepostEventPageLoadable } from './OrgDashboardRepostEventPageLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
  params: { orgId, eventId },
}: HorizonAppRouteLoaderArgs<typeof orgDashboardRepostEventRoute>) {
  const [event] = await Promise.all([
    orgDashboardApiIsomorphicFetchEvent({ request, context })(orgId, eventId),
    OrgDashboardRepostEventPageLoadable.load(),
  ]);

  return { event };
}

export default function OrgDashboardRepostEventHorizonRoute({
  loaderData: { event },
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Repost an Event')}>
      <OrgDashboardRepostEventPageLoadable event={event} />
    </RouteModule>
  );
}
